const Home = () => (
  <>
    <h1 className="text-2xl">Nonalu</h1>
    <div>Content Management</div>
  </>
)

export default Home
